// extracted by mini-css-extract-plugin
export default {"logo_link":"VerifyCertificate_logo_link__sjly2","overflow_wrap":"VerifyCertificate_overflow_wrap__ZxK-B","old_certificate_img":"VerifyCertificate_old_certificate_img__QJl+y"};